export const SingleProductForReview = ({
  product,
  selectedProductId,
  setSelectedProductId,
}) => {
  return (
    <label
      className={`${selectedProductId === product.productID ? 'bg-[#FFDE11]' : 'border'} rounded-[10px] font-medium font-duplet text-sm px-2 py-2 flex justify-between items-center min-w-[200px]  cursor-pointer`}
    >
      <div className="flex space-x-2">
        <img
          src={product?.coverImage || '/images/product-placeholder.svg'}
          alt={product?.productName || 'Product Image'}
          className="w-16 h-16 object-cover rounded-md"
        />
        <div>
          <h3 className="font-duplet text-sm font-medium">
            {(product?.productName?.length > 26
              ? product.productName.slice(0, 26) + '...'
              : product?.productName) || 'Product Name'}
          </h3>
        </div>
      </div>
      <input
        type="radio"
        className="w-4 h-4 accent-black"
        onClick={() => setSelectedProductId(product.productID)}
      />
    </label>
  );
};
